import React from "react";
import Router from "./components/Router";
import { voiceStore } from "./stores/voiceStore";
import { Provider } from 'mobx-react';

const CustomerApp = () => {

  return (
    <Provider voiceStore={voiceStore}>
      <Router />
    </Provider>
  );
};

export default CustomerApp;
